import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormInput from '../../../../../library/form/components/FormInput';
import FormWrapper from "../../../../../library/form/components/FormWrapper";

const ProdIOOOutExoRow = (props) => {
    const { formObject, index, rowKey } = props;

    return (
        <ul className="uiDPEditLine">
            <li className="uiColumnCenter uiColumn30">
                <span>{index}</span>
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
            </li>
            <li className="uiColumnCenter uiColumn150">
                <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                    action={{ paramName: "actualItem", actionId: "show" }}
                    linkProp={{ target: "_blank" }}
                ></FormLink>
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
            </li>
            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                action={{ paramName: "variation1Name" }} >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
            </FormWrapper>
            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                action={{ paramName: "variation2Name" }} >
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
            </FormWrapper>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "reqQty" }} />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "actionedQty" }} />
            </li>
            <li className="uiColumnCenter uiColumn130">
                <FormInput formObject={formObject} rowKey={rowKey} className="uiInput uiWidth55"
                    action={{ InputType: "input", actionId: "refresh", paramName: "qcQty1",actionParam: { updateQty : "1"} }} />
                <FormInput formObject={formObject} rowKey={rowKey} className="uiInput uiWidth55"
                    action={{ InputType: "input", actionId: "refresh", paramName: "qcQty2",actionParam: { updateQty : "1"} }} />
            </li>
        </ul>
    )
}

export default ProdIOOOutExoRow